import { TableColumn } from '../types/TableColumn';

export const renderColumnCell = <T extends object>(column: TableColumn<T>, value: T) => {
  if (column.renderCell) return column.renderCell(value);

  if (column.key in value) return value[column.key as keyof T] as unknown as string;

  return '';
};
